/* eslint-disable react/prop-types */
import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import AuthServiceRambla from 'api/services/AuthServiceRambla';
import { toastr } from 'utils';
import { useTranslation } from 'react-i18next';
import { Form, Modal, ModalFooter } from 'components';

const PasswordChangeModal = ({ setIsPasswordModalOpen }) => {
  const { t: appT } = useTranslation(['app']);
  const { t } = useTranslation('ownerPortal', { keyPrefix: 'changeSocialInfoModal' });
  const { t: tToastr } = useTranslation('toastr');

  const [isFormChanged, setIsFormChanged] = useState(false);
  const formRef = useRef(null);

  const TrackPasswordFormChanges = ({ formValues, localSetIsFormChanged }) => {
    useEffect(() => {
      const localIsFormChanged =
        !!formValues.currentPassword &&
        !!formValues.newPassword &&
        !!formValues.confirmNewPassword &&
        formValues.newPassword === formValues.confirmNewPassword;
      localSetIsFormChanged(localIsFormChanged);
    }, [formValues, localSetIsFormChanged]);

    return null;
  };

  const handlePasswordSubmit = async (formValues) => {
    try {
      await AuthServiceRambla.changePasswordLogged(
        formValues.currentPassword,
        formValues.newPassword,
      );

      toastr.success(t('toastr:success'), tToastr('passwordChangeSuccess'));
    } catch (error) {
      toastr.error(t('toastr:error'), tToastr('passwordChangeError'));
    }
    setIsPasswordModalOpen(false);
  };

  return (
    <Modal
      open
      onClose={() => setIsPasswordModalOpen(false)}
      header={{
        title: t('changePasswordTab'),
      }}
      closeButton
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        width: '500px',
        maxHeight: '60vh',
      }}
      footer={(closePopup) => (
        <ModalFooter
          onCancel={closePopup}
          onSave={() => formRef.current?.submitForm()}
          cancelText={appT('cancel').toUpperCase()}
          saveText={appT('save').toUpperCase()}
          isSaveDisabled={!isFormChanged}
        />
      )}
    >
      <Form
        innerRef={formRef}
        initialValues={{
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        }}
        enableReinitialize={false}
        onSubmit={handlePasswordSubmit}
        renderDefaultButtons={false}
      >
        {({ values }) => (
          <>
            <TrackPasswordFormChanges
              formValues={values}
              localSetIsFormChanged={setIsFormChanged}
            />
            <FormWrapper>
              <NameWrapper>
                <Form.Label>{t('currentPassword')}</Form.Label>
                <Form.Input
                  type="password"
                  name="currentPassword"
                  placeholder={t('currentPasswordPlaceholder')}
                />
              </NameWrapper>
              <NameWrapper>
                <Form.Label>{t('newPassword')}</Form.Label>
                <Form.Input
                  type="password"
                  name="newPassword"
                  placeholder={t('newPasswordPlaceholder')}
                />
              </NameWrapper>
              <NameWrapper>
                <Form.Label>{t('confirmNewPassword')}</Form.Label>
                <Form.Input
                  type="password"
                  name="confirmNewPassword"
                  placeholder={t('confirmNewPasswordPlaceholder')}
                />
              </NameWrapper>
            </FormWrapper>
          </>
        )}
      </Form>
    </Modal>
  );
};

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const NameWrapper = styled.div`
  margin-bottom: 15px;
`;

PasswordChangeModal.propTypes = {
  setIsPasswordModalOpen: PropTypes.func.isRequired,
};

export default PasswordChangeModal;
